export enum IsActive {
  inactive = 0,
  both = 2,
  active = 3
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/model/enum/is-active.ts